import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import CancellationOfferInputFields from '../../components/cancellationOffers/cancellationOfferInputFields'

import * as actions from './actions'
import { routePrefix } from '../../config';

import './styles.css'

class CreateEditOffer extends React.Component {

  constructor(props) {
    super(props);

    let isEditCase = false;
    if(props.match.params.id) {
      isEditCase = true;
    }

    this.state = {
      isEditCase,
      focusedEndDate: null,
      focusedExcluedDate: null,
      endDate: null,
      excludeDate: null,
      source: null,
      destination: null,
      selectedServices: [],
      isDataFetched: false,
      isRoutesPopulated: false,
      isAllServicesSelected: true,
      servicesObj: {},
      hoursBeforeDep: '',
    }
    this.date = moment().format('DD-MMM-YYYY');
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // in case of edit prefill the state data
    if(prevState.isEditCase && !prevState.isDataFetched && nextProps.offerData) {
      const offerData = nextProps.offerData;
      return {
        selectedServices: Object.values(offerData.routes_services || {}).reduce((acc, val) => acc.concat(val), []) || [],
        endDate: moment(offerData.end_date),
        isDataFetched: true,
        isAllServicesSelected: false,
        paytm_route: offerData.paytm_route,
        hoursBeforeDep: offerData.hoursBeforeDep,
      }
    }
    if(!prevState.isRoutesPopulated && nextProps.paytmCitiesMap && nextProps.offerData && nextProps.offerData.paytm_route) {
      const [sourceId, destId] = nextProps.offerData.paytm_route.split('-');
      // set the source and destination object from operator routes
      return {
        source: { city_id: sourceId, name: nextProps.paytmCitiesMap[sourceId] },
        destination: { city_id: destId, name: nextProps.paytmCitiesMap[destId] },
        isRoutesPopulated: true
      };
    }
    return null;
  }

  componentDidMount() {
    if(this.state.isEditCase) {
      this.props.fetchOfferData(this.props.match.params.id, this.props.match.params.paytmRoute);

      // fetch the cities list in edit case of page refresh
      if(!this.props.paytmCitiesMap)
        this.props.getOperatorRoutes();
    }
  }

  componentWillUnmount() {
    this.props.clearOfferData();
  }

  onInputFieldChange = (value, name) => this.setState({ [name]: value })

  onEndFocusChange = ({ focused }) => this.setState({ focusedEndDate: focused })

  onEndDateChange = date => {
    if(!date) return;
    this.setState({ endDate: date, excludedDatesArr: [] });
  }

  endDateRangeChecker = (date) => moment().diff(date) > 0

  fetchCities = (value, fieldType) => {
    this.props.fetchCities(value, fieldType);
  }

  onDestinationInputChange = () => {}

  onSourceItemSelect = (item) => {
    this.setState({ source: item })
  }

  onDestinationItemSelect = (item) => {
    this.setState({ destination: item })
  }

  onServiceOptionChange = (label, isChecked) => {
    this.setState({
      isAllServicesSelected: label === 'Selected Service'? !isChecked: isChecked,
      selectedServices: []
    })
  }

  onSearchClick = () => {
    const { source, destination, journeyDate } = this.state;
    if(!source || !destination) {
      alert('Please select a valid value of source and destination.');
      return;
    }
    this.props.fetchServices({
      srcId: source.city_id,
      destId: destination.city_id,
    });
  }

  onSearvicesSelection = (routeTimeId, isChecked) => {
    this.setState(prevState => ({
      selectedServices: isChecked ?
        prevState.selectedServices.concat(routeTimeId)
        : prevState.selectedServices.filter(el => el != routeTimeId)
    }))
  }

  onCancelClick = () => this.props.history.push(routePrefix + '/cancellation-offer')

  onCreateOfferClick = () => {
    const {
      source,
      endDate,
      isEditCase,
      destination,
      selectedServices,
      hoursBeforeDep,
      isAllServicesSelected,
    } = this.state;

    // if user is clicking create without source and destination
    if(!source || !destination) {
      alert('Please select a valid value of source and destination.');
      return;
    }

    if(!endDate) {
      alert('Kindly select the end date.');
      return;
    }

    if(!isAllServicesSelected && !selectedServices.length) {
      alert('Kindly select the service.');
      return;
    }

    if(!this.props.routeServices.length) {
      alert('Kindly search and select the services.');
      return;
    }

    if(!hoursBeforeDep) {
      alert('Kindly fill the hours before departure value');
      return;
    }

    let obj = {
      start_date: moment().format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
      paytm_route: source.city_id + '-' + destination.city_id,
      applicable_days: ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'],
    }

    let service_ids = [], formattedSelectedServices = {};
    // format: formattedSelectedServices: { "provider_srcid-provider_dest": [route_time_ids] }
    // in case of all services, the ids of all the items
    if(isAllServicesSelected) {
      this.props.routeServices.forEach(el => {
        // if(this.state.isEditCase) service_ids.push(el.route_time_id);
        // else {
          let key = el.provider_source_id + '-' + el.provider_destination_id;
          formattedSelectedServices[key] = (formattedSelectedServices[key] || []).concat(el.route_time_id);
        // }
      })
    } else {
      // if(!this.state.isEditCase) {
        selectedServices.forEach(id => {
          let obj = this.props.routeServices.find(el => el.route_time_id == id);
          if(obj) {
            let key = obj.provider_source_id + '-' + obj.provider_destination_id;
            formattedSelectedServices[key] = (formattedSelectedServices[key] || []).concat(id);
          }
        });
      // } else
      //   service_ids = selectedServices;
    }

    obj.new_format_policy = [
      {
        start_time: -1,
        end_time: hoursBeforeDep * 60,
        refund_amount: 0,
        refund_percentage: 100
      },
      {
        start_time: hoursBeforeDep * 60,
        end_time: 0,
        refund_amount: 0,
        refund_percentage: 0,
      }
    ];

    obj.old_format_policy = [
      {
        "departure_heading": "Hours before Departure",
        "policy_heading": "Refund Percentage"
      },
      {
        "departure_heading": `Between 0 Hrs. to ${hoursBeforeDep} Hrs.`,
        "policy_heading": '0%',
      },
      {
        "departure_heading": `Before ${hoursBeforeDep} hrs`,
        "policy_heading": '100%'
      },
    ]

    obj.routes_services = formattedSelectedServices;

    if(isEditCase) {
      // obj.service_ids = service_ids;
      obj = { ...this.props.offerData, ...obj };
      this.props.updateOffer(obj, () => this.props.history.push(routePrefix + '/cancellation-offer'));
    } else {
      // obj.route_services = formattedSelectedServices;
      this.props.createOffer(obj, () => this.props.history.push(routePrefix + '/cancellation-offer'));
    }
  }

  render() {
    return (
      <div className="payout">
        <div className="row create-deal-header">
          <p className="payout-header-text">{this.state.isEditCase? 'Update': 'Create a'} Cancellation Offer</p>
          <p className="payout-updated-date">{this.date}</p>
        </div>
        <CancellationOfferInputFields
          isEditCase={this.state.isEditCase}
          hoursBeforeDep={this.state.hoursBeforeDep}
          source={this.state.source}
          destination={this.state.destination}
          endDate={this.state.endDate}
          focusedEndDate={this.state.focusedEndDate}
          onInputFieldChange={this.onInputFieldChange}
          routeServices={this.props.routeServices}
          selectedServices={this.state.selectedServices}
          isAllServicesSelected={this.state.isAllServicesSelected}
          onEndFocusChange={this.onEndFocusChange}
          onEndDateChange={this.onEndDateChange}
          endDateRangeChecker={this.endDateRangeChecker}
          onSourceItemSelect={this.onSourceItemSelect}
          onDestinationItemSelect={this.onDestinationItemSelect}
          onSearvicesSelection={this.onSearvicesSelection}
          onServiceOptionChange={this.onServiceOptionChange}
          onSearchClick={this.onSearchClick}
          onCancelClick={this.onCancelClick}
          onCreateOfferClick={this.onCreateOfferClick}
        />
        <div className="col-xs-3" />
      </div>
    )
  }
}

const mapStateToProps = store => ({
  offerData: store.cancellationOffers.offerData,
  paytmCitiesMap: store.cancellationOffers.paytmCitiesMap,
  routeServices: store.cancellationOffers.routeServices,
  sourceCityData: store.cancellationOffers.sourceCityData,
  destCityData: store.cancellationOffers.destCityData,
})

const mapDispatchToProps = dispatch => ({
  getOperatorRoutes: () => dispatch(actions.getOperatorRoutes()),
  fetchOfferData: (id, paytmRoute) => dispatch(actions.fetchOfferData(id, paytmRoute)),
  clearOfferData: () => dispatch(actions.clearOfferData()),
  fetchServices: (query) => dispatch(actions.fetchServices(query)),
  createOffer: (data, callback) => dispatch(actions.createOffer(data, callback)),
  updateOffer: (data, callback) => dispatch(actions.updateOffer(data, callback)),
})

CreateEditOffer.propTypes = {}

export default connect(mapStateToProps, mapDispatchToProps)(CreateEditOffer)
